import Vue from 'vue'
import Vuex from 'vuex'
// util
import Util from '@/utils/util'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    navigateTitle: '',
    navigateStyle: '',
    hasHeader: '',
    chooseBank: { isNull: true },
    gdtInfo: { isNull: true }, // 广点通广告信息 click_id: '' ,entry
    newApplyInfo: { isNull: true }, // 2.0 新卡申办信息，包括跳转信息
    currentOrder: { isNull: true }, // 当前订单信息
    currentCard: { isNull: true, is_king: 1 }, // 当前申请卡片，默认王卡
    currentIssuer: { isNull: true }, // 当前申请发卡方
    userLocation: { isNull: true }, // 用户位置，包括定位城市，经纬度，身份证位置，行驶证位置
    userApplyStep: null, // 用户申办步骤   0:无步骤 1:定制卡片第一步manuApply(1,) 2:上传身份证页uploadIDCard(2,1) 3:免密页paySuccess 4:绑定成功页 5:办卡进度 6:个人中心
    applyOrderInfo: {}, // 用户提交地址时的车辆信息及省份  用来创建订单
    applyStepList: {}, // 重构后的申办步奏
    lastApplyInfo: {}
  },
  /* // 在单独构建的版本中辅助函数为 Vuex.mapState
  import { mapState } from 'vuex'
  export default {
    // ...
    computed: mapState({
      // 箭头函数可使代码更简练
      count: state => state.count,
      // 传字符串参数 'count' 等同于 `state => state.count`
      countAlias: 'count',
      // 为了能够使用 `this` 获取局部状态，必须使用常规函数
      countPlusLocalState (state) {
        return state.count + this.localCount
      }
    })
  } */
  getters: {},
  /* 映射
  import { mapMutations, mapActions } from 'vuex'
  export default {
    // ...
    methods: {
      ...mapMutations([
        'increment', // 将 `this.increment()` 映射为 `this.$store.commit('increment')`
        // `mapMutations` 也支持载荷：
        'incrementBy' // 将 `this.incrementBy(amount)` 映射为 `this.$store.commit('incrementBy', amount)`
      ]),
      ...mapMutations({
        add: 'increment' // 将 `this.add()` 映射为 `this.$store.commit('increment')`
      })
    }
  } */
  mutations: {
    // 提交变更状态，同步
    setNavigateStyle(state, data) {
      state.navigateStyle = data
    },
    setNavigateTitle(state, data) {
      state.navigateTitle = data
    },
    setHasHeader(state, data) {
      state.hasHeader = data
    },
    setGDTInfo(state, data) {
      state.gdtInfo = data
    },
    setChooseBank(state, data) {
      if (Util.isNull(data)) {
        state.chooseBank = { isNull: true }
      } else {
        Util.deepAssign(state.chooseBank, { isNull: false, ...data })
      }
      localStorage.setItem('chooseBank', JSON.stringify(state.chooseBank))
    },
    resetChooseBank(state, data) {
      state.chooseBank = data
      localStorage.setItem('chooseBank', JSON.stringify(state.chooseBank))
    },
    setNewApplyInfo(state, data) {
      if (Util.isNull(data)) {
        state.newApplyInfo = { isNull: true }
      } else {
        Util.deepAssign(state.newApplyInfo, { isNull: false, ...data })
      }
      localStorage.setItem('newApplyInfo', JSON.stringify(state.newApplyInfo))
    },
    setCurrentOrder(state, data) {
      if (Util.isNull(data)) {
        state.currentOrder = { isNull: true }
      } else {
        Util.deepAssign(state.currentOrder, { isNull: false, ...data })
      }
      localStorage.setItem('currentOrder', JSON.stringify(state.currentOrder))
    },
    upDateApplyIsReconApply(state, data) {
      if (Util.isNull(data)) {
        state.reconApply = { isNull: true }
      } else {
        Util.deepAssign(state.reconApply, { isNull: false, ...data })
      }
      localStorage.setItem('reconApply', JSON.stringify(state.isNew))
    },
    setCurrentCard(state, data) {
      if (Util.isNull(data)) {
        state.currentCard = { isNull: true }
      } else {
        Util.deepAssign(state.currentCard, { isNull: false, ...data })
      }
      localStorage.setItem('currentCard', JSON.stringify(state.currentCard))
    },
    setCurrentIssuer(state, data) {
      if (Util.isNull(data)) {
        state.currentIssuer = { isNull: true }
      } else {
        Util.deepAssign(state.currentIssuer, { isNull: false, ...data })
      }
      localStorage.setItem('currentIssuer', JSON.stringify(state.currentIssuer))
    },
    setUserApplyStep(state, data) {
      state.userApplyStep = data
    },
    setUserLocation(state, data) {
      if (Util.isNull(data)) {
        state.userLocation = { isNull: true }
      } else {
        Util.deepAssign(state.userLocation, { isNull: false, ...data })
      }
    },
    setApplyOrderInfo(state, data) {
      state.applyOrderInfo = data
    },
    setApplyStepList(state, data) {
      state.applyStepList = data
    },
    setLastApplyInfo(state, data) {
      state.lastApplyInfo = data
    }
  },
  actions: {
    // 分发状态，可异步
    // store.dispatch('incrementAsync', {amount: 10})
    // setCurrentOrder({commit}, data) {
    //   commit('setCurrentOrder', data)
    // }
  }
})
